export default "__VITE_ASSET__BvxFTHoX__"